import React, { Fragment, useEffect, useState } from 'react';
import {
  Row,
  Col,
  Card,
  FormGroup,
  CardBody,
  Button,
  Input,
  Spinner,
  Label,
} from 'reactstrap';
import { Colxx, Separator } from '../../../../../components/common/CustomBootstrap';
import IntlMessages from '../../../../../helpers/IntlMessages';
import {
  AxiosAPI,
  getGroupID,
  getUserID,
} from '../../../../../helpers/AxiosAPI';
import {
  API_External_Source,
  gAPI_Users_By_Id,
  API_WAYS_Integration_Item,
} from '../../../../../constants/APIs';

import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import sync_ways from '../../../../../assets/ways_sync.png';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import Select from 'react-select';
import CustomSelectInput from '../../../../../components/common/CustomSelectInput';
const WaysForm = ({
  propertyId,
  email,
  locale,
  submit,
  LoadData,
  waysData,
  waysIntegration,
  categoriesItems,
}) => {
  const [open, setOpen] = useState(false);
  const [isloading, setIsLoading] = useState(true);
  const [msg, setMsg] = useState([]);
  const [configurations, setConfigurations] = useState([]);
  const [sourceData, setSourceData] = useState({
    groupId: getGroupID(),
    propertyId: propertyId,
    createdBy: 'Admin',
    sourceStatus: 'Active',
    sourceType: 'Ways',
    name: 'Ways Sync',
    frequency: 'Weekly',
    webPages: [],
    faqList: [],
    waysConfiguration: [],
    enableFAQ: false,
    email: email,
  });
  const [categories, setCategories] = useState(categoriesItems);

  useEffect(() => {
    if (waysData?.id) {
      AxiosAPI({
        method: 'get',
        url: `${API_External_Source}/${waysData?.id}`,
      }).then((res) => {
        const data = res.data;
        if (data.faqList === null) data.faqList = [];
        if (
          data.waysConfiguration !== null &&
          data.waysConfiguration !== undefined &&
          data.waysConfiguration.length > 0
        ) {
          var selectedProd = [];
          data.waysConfiguration.map((r) => {
            var products = [];
            categoriesItems
              .filter((x) => x.value === r.category)
              .map((x) =>
                x.products.map((p) => {
                  if (
                    r.items !== null &&
                    r.items.length > 0 &&
                    r.items.includes(p.value)
                  ) {
                    products.push(p);
                  }
                })
              );
            selectedProd.push({ category: r.category, products: products });
          });
          setConfigurations(selectedProd);
          setSourceData({
            ...data,
            name: 'Ways Sync',
            groupId: getGroupID(),
            propertyId: propertyId,
            createdBy: 'Admin',
            email: email,
          });
          setCategories(categoriesItems);
          setIsLoading(false);
        }
      });
    } else {
      setCategories(categoriesItems);
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
  }, [waysData, propertyId]);

  const handlewaysCategory = (e, index) => {
    let configuration = [...sourceData.waysConfiguration];
    configuration[index].category = e.target.value;
    setSourceData({ ...sourceData, waysConfiguration: configuration });
    let config = [...configurations];
    config[index].category = e.target.value;
    console.log(configurations, e.target.value);
    setConfigurations(config);
  };

  const handleChange = (e) => {
    setSourceData({ ...sourceData, [e.target.name]: e.target.value });
  };

  const handleSyncManualy = (item) => {
    handleSync(item);
  };

  const handleAddConfiguration = () => {
    let lst = [...sourceData.waysConfiguration];
    lst.push({ category: '', items: [] });
    let configList = [...configurations];
    configList.push({ category: '', products: [] });
    setConfigurations(configList);
    setSourceData({ ...sourceData, waysConfiguration: lst });
  };

  const handleRemoveConfiguration = (val) => {
    let lst = [...sourceData.waysConfiguration];
    lst = lst.filter((f, index) => index !== val);
    let configList = [...configurations];
    configList = configList.filter((f, index) => index !== val);
    setConfigurations(configList);
    setSourceData({ ...sourceData, waysConfiguration: lst });
  };

  const handleSync = (item) => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
    }).then((res) => {
      AxiosAPI({
        method: 'put',
        url: `${API_External_Source}/${item.id}`,
        data: {
          userName: res.data.fullName,
          isManual: true,
          email: email,
        },
      }).then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          NotificationManager.success(
            '',
            'We have received your request. It will take few minutes.',
            3000,
            null,
            null,
            'success'
          );
          LoadData();
        }
      });
    });
  };

  const handleSave = () => {
    const data = {
      ...sourceData,
      name: 'Ways Sync',
      groupId: getGroupID(),
      propertyId: propertyId,
      createdBy: 'Admin',
      email: email,
    };

    if (sourceData?.id) {
      AxiosAPI({
        method: 'put',
        url: `${API_External_Source}/${sourceData.id}`,
        data: data,
      })
        .then((res) => {
          NotificationManager.success('Updated successfully', '', 3000);
          LoadData();
        })
        .catch((err) => {
          NotificationManager.error('Update failed', '', 3000);
          console.error(err);
        });
    } else {
      console.log(JSON.stringify(sourceData));
      submit(sourceData);
    }
  };

  const handlewaysItems = (options, index) => {
    let config = [...configurations];
    config[index].products = options;
    setConfigurations(config);

    let lst = [...sourceData.waysConfiguration];
    lst[index].items = options.map((i) => i.value);
    setSourceData({ ...sourceData, waysConfiguration: lst });
  };
  return (
    <Fragment>
      {isloading ? (
        <div className="loading" />
      ) : (
        <Card className="p-2">
          <CardBody className="m-0">
            <Col md="12" className="px-0">
              <img src={sync_ways} style={{ maxWidth: '100%', height: 'auto' }} />
            </Col>
            <Col md="12" className="px-0 my-3 mx-2">
              <Row>
                {/* <Colxx sm={3} className="mb-3">
                  <Label>
                    <IntlMessages id='dashboards.title' /> <span style={{ color: 'red' }}> *</span>
                  </Label>
                  <Input
                    value={sourceData.name}
                    name="name"
                    onChange={handleChange}
                    disabled
                  ></Input>
                </Colxx> */}
                <Colxx sm={3} className="mb-3">
                  <Label>
                    <IntlMessages id="pages.status" />{' '}
                    <span style={{ color: 'red' }}> *</span>
                  </Label>
                  <Input
                    type="select"
                    value={sourceData.status}
                    name="status"
                    onChange={handleChange}
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </Input>
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <Label>
                    <IntlMessages id="dashboards.frequency" />{' '}
                    <span style={{ color: 'red' }}> *</span>
                  </Label>
                  <Input
                    type="select"
                    value={sourceData.frequency}
                    name="frequency"
                    onChange={handleChange}
                  >
                    {/* <option value="Daily">Daily</option> */}
                    <option value="Weekly">Weekly</option>
                    <option value="Monthly">Monthly</option>
                    <option value="Manually">Manually</option>
                  </Input>
                </Colxx>
              </Row>
              <p className="mb-2">
                With integration to <b>Way</b>, you can sync{' '}
                <b>item descriptions</b> from ways directly into your AI
                Assistant on a set schedule. This ensures your AI has the most
                up-to-date information to assist users.
              </p>
            </Col>
            <Row className="ml-1">
              <Colxx sm={12} className="mb-1 px-0 mx-2">
                <FormGroup className="m-0">
                  {sourceData?.waysConfiguration &&
                    sourceData.waysConfiguration.map((m, index) => (
                      <Fragment>
                        <Row>
                          <Colxx sm={3} className="mb-1">
                            <Label for="webPages">
                              <IntlMessages id="dashboards.category" />
                              <span style={{ color: 'red' }}> *</span>
                            </Label>
                          </Colxx>
                          <Colxx sm={6} className="mb-1">
                            <Label for="webPages">Items</Label>
                          </Colxx>
                        </Row>
                        <Row className="mb-1">
                          <Colxx sm={3} className="mb-2">
                            <Input
                              type="select"
                              name="category"
                              value={m.category}
                              onChange={(e) => handlewaysCategory(e, index)}
                            >
                              <option value="">Select</option>
                              {categories.length > 0 &&
                                categories.map((k) => (
                                  <option value={k.value}>{k.label}</option>
                                ))}
                            </Input>
                          </Colxx>
                          <Colxx sm={6} className="mb-2">
                            <Select
                              components={{ Input: CustomSelectInput }}
                              className="react-select"
                              classNamePrefix="react-select"
                              name="form-field-name"
                              placeholder="Select Items"
                              isMulti={true}
                              options={
                                categories.filter(
                                  (i) => i.value === m.category
                                ).length > 0
                                  ? categories.filter(
                                    (i) => i.value === m.category
                                  )[0].products
                                  : []
                              }
                              value={configurations[index].products}
                              onChange={(val) => handlewaysItems(val, index)}
                            />
                          </Colxx>
                          <Colxx sm={2} className="mb-2 text-center d-flex align-items-center">
                            <Button
                              outline
                              size="xs"
                              color="danger"
                              onClick={() => handleRemoveConfiguration(index)}
                            >
                              X
                            </Button>
                          </Colxx>
                        </Row>
                      </Fragment>
                    ))}
                </FormGroup>
              </Colxx>
            </Row>
            <Row className="ml-1">
              <Colxx md={5} className="mb-3 px-1">
                <Button
                  outline
                  color="primary"
                  size="xs"
                  onClick={() => handleAddConfiguration()}
                >
                  <IntlMessages id="dashboards.addItem" />
                </Button>
              </Colxx>
            </Row>
            <Separator className="mb-3" />
            <Row className="ml-1 my-2">
              <Col md={12} className="px-0 text-end">
                <Button
                  color="primary"
                  size="xs"
                  onClick={() => handleSyncManualy(sourceData)}
                >
                  <IntlMessages id="dashboards.sync" />
                </Button>
                <Button
                  color="secondary"
                  onClick={handleSave}
                  size="xs"
                  className="ml-3"
                >
                  <span className="label">
                    <IntlMessages id="dashboards.save" />
                  </span>
                </Button>
              </Col>
            </Row>
          </CardBody>
        </Card>
      )}
    </Fragment>
  );
};
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale, email } = settings;
  return {
    propertyId,
    locale,
    email,
  };
};

export default injectIntl(connect(mapStateToProps, {})(WaysForm));
